module.exports = __webpack_public_path__ + "static/media/balloons_deals.3831ab2b.png";